import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { appRoutes } from './app.routes';
import { loaderInterceptor } from '@/core/interceptors/loader.interceptor';
import { jwtInterceptor } from '@/core/interceptors/jwt.interceptor';
import { errorInterceptor } from '@/core/interceptors/error.interceptor';
import { provideFormlyCore } from '@ngx-formly/core';
import { withFormlyPrimeNG } from '@ngx-formly/primeng';
import { FormlyWrapperFormField } from '@shared/formly/wrappers/form-field.wrapper';
import { FormlyWrapperNon } from '@shared/formly/wrappers/form-field-nowrapper';
import { FormlyCenterWrapper } from '@shared/formly/wrappers/form-field-center.wrapper';
import { FormlyWrapperFormFieldOffset3 } from '@shared/formly/wrappers/form-field-offset-3.wrapper';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
        provideHttpClient(withFetch(), withInterceptors([loaderInterceptor, jwtInterceptor, errorInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        provideFormlyCore([
            ...withFormlyPrimeNG(),
            {
                wrappers: [
                    { name: 'form-field', component: FormlyWrapperFormField },
                    { name: 'no-wrap', component: FormlyWrapperNon },
                    { name: 'center', component: FormlyCenterWrapper },
                    { name: 'offset-3', component: FormlyWrapperFormFieldOffset3 }
                ],
                types: [
                    // { name: 'datepicker', component: FormlyFieldPrimeNgDatepicker, wrappers: ['form-field'] },
                    // { name: 'repeat', component: FormlyRepeatSectionTypeComponent, wrappers: ['form-field'] },
                    // { name: 'multiselect', component: FormlyFieldMultiSelect, wrappers: ['form-field'] },
                    // { name: 'listbox', component: FormlyFieldListBox, wrappers: ['form-field'] },
                    // {name: 'file', component: FormlyFieldFile, wrappers: ['form-field']},
                    // {name: 'file-input', component: FormlyFieldFileInputType, wrappers: ['form-field']},
                    // {name: 'tabs', component: FormlyFieldTabs, wrappers: ['form-field']},
                    // { name: 'chips', component: FormlyFieldChips, wrappers: ['form-field'] },
                    // {name: 'course-select', component: FormlyFieldCourseSelect, wrappers: ['form-field']},
                    // {name: 'custom-select', component: CustomSelectComponent, wrappers: ['form-field']},
                    // {name: 'html', component: FormlyFieldHtml, wrappers: ['form-field']},
                    // {name: 'checkbox', component: FormlyFieldCheckbox, wrappers: ['offset-3']},
                    // { name: 'number', component: FormlyFieldNumber, wrappers: ['form-field'] }
                ]
                // validators: [{name: 'time', validation: TimeFormatValidator}],
                // validationMessages: [
                //   {name: 'time', message: TimeFormatValidatorMessage},
                //   {name: 'number', message: NumberValidatorMessage},
                // ],
            }
        ]),
        MessageService,
        ConfirmationService,
        DialogService
    ]
};
